import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {_} from 'utils/i18n';
import {IDType} from 'utils/prop-types';

import Button from 'scripts/components/Button';

const Label = _('Submit');

class AbortButton extends PureComponent {

    static propTypes = {
        value: IDType.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    render() {
        return (
            <Button className="modal-action modal-close" onClick={this.handleClick} flat>
                {Label}
            </Button>
        );
    }

    handleClick() {
        const {value, onClick} = this.props;

        return onClick(value);
    }

}

export default AbortButton;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/LessonAbortModal/AbortButton.js